export const schematicJSON_Original = {
  nodes: [
    { id: "gp_well", type: "source", label: "GP Well", name: "GP Well" },
    { id: "coh", type: "label", label: "COH", name: "COH" },
    { id: "commonline", type: "structure", label: "", name: "" },
    { id: "commonline2", type: "structure", label: "", name: "" },
    { id: "commonline3", type: "structure", label: "", name: "" },
    { id: "commonline5", type: "structure", label: "", name: "" },
    { id: "commonline6", type: "structure", label: "", name: "" },
    { id: "commonline7", type: "structure", label: "", name: "" },
    { id: "commonline8", type: "structure", label: "", name: "" },
    { id: "commonline9", type: "structure", label: "", name: "" },
    { id: "commonline10", type: "structure", label: "", name: "" },
    { id: "meter_101893", type: "meter", label: "101893", name: "101893" },
    { id: "tank", type: "storage", label: "Tank", name: "Tank" },
    { id: "meter_162902", type: "meter", label: "162902", name: "162902" },
    { id: "water_plant", type: "plant", label: "Water Plant", name: "Water Plant" },
    { id: "north_distribution_meter", type: "meter", label: "95434", name: "95434" },
    { id: "south_distribution_meter", type: "meter", label: "126171", name: "126171" },
    { id: "total_produced", type: "process", label: "Total Produced", name: "Produced" },
    { id: "meter_150850", type: "meter", label: "150850", name: "150850" },
    { id: "meter_150849", type: "meter", label: "150849", name: "150849" },
    { id: "potable_supply", type: "supply", label: "Potable Supply", name: "Potable_Supply" },
    { id: "consumer_potable", type: "consumer", label: "Consumer Potable Meters", name: "Potable_Demand" },
    { id: "non_potable_reservoir", type: "reservoir", label: "Non Potable Reservoir", name: "Non Potable Reservoir" },
    { id: "non_potable_plant", type: "pump", label: "Non Potable Plant", name: "Non Potable Plant" },
    { id: "meter_206680", type: "meter", label: "206680", name: "206680" },
    { id: "meter_195026", type: "meter", label: "195026/195027", name: "NPS(P1)" },
    { id: "meter_129122", type: "meter", label: "129122/129123", name: "NPS(P2)" },
    { id: "meter_114476", type: "meter", label: "114476", name: "114476" },
    { id: "meter_114477", type: "meter", label: "114477", name: "114477" },
    { id: "non_potable_supply", type: "supply", label: "Non Potable Supply", name: "NPS(NP)" },
    { id: "consumer_non_potable", type: "consumer", label: "Consumer Non Potable Meters", name: "Non_Potable_Demand" },
  ],
  edges: [
    { from: "gp_well", to: "meter_101893" },
    { from: "meter_101893", to: "tank" },
    { from: "coh", to: "meter_162902" },
    { from: "meter_162902", to: "tank" },
    { from: "tank", to: "water_plant" }, 
    { from: "water_plant", to: "north_distribution_meter" },
    { from: "water_plant", to: "south_distribution_meter" },
    // { from: "meter_150850", to: "commonline3" },
    { from: "north_distribution_meter", to: "meter_150849" },
    { from: "north_distribution_meter", to: "meter_150850" },
    { from: "north_distribution_meter", to: "total_produced" },
    { from: "south_distribution_meter", to: "total_produced" },
    { from: "potable_supply", to: "consumer_potable" },
    { from: "commonline2", to: "potable_supply" },
    { from: "south_distribution_meter", to: "commonline6" },
    { from: "non_potable_reservoir", to: "non_potable_plant" },
    { from: "non_potable_plant", to: "meter_206680" },
    { from: "non_potable_plant", to: "commonline5" },
    { from: "commonline5", to: "commonline8" },
    // { from: "meter_206680", to: "commonline9" },
    { from: "meter_206680", to: "non_potable_reservoir" },
    // { from: "commonline9", to: "non_potable_reservoir" },
    { from: "commonline5", to: "meter_114477" },
    { from: "meter_195026", to: "meter_129122" },
    { from: "meter_129122", to: "consumer_non_potable" },
    { from: "commonline", to: "meter_129122" },
    { from: "meter_150849", to: "commonline3" },
    { from: "commonline7", to: "commonline10" },
    // { from: "commonline10", to: "meter_150850" },
    // { from: "commonline8", to: "meter_114476" },
    // { from: "meter_150850", to: "commonline7" },
    { from: "meter_114476", to: "non_potable_supply" },
    { from: "meter_114477", to: "non_potable_supply" },
    { from: "non_potable_supply", to: "consumer_non_potable" },
    // { from: "meter_195026", to: "commonline5" }, 
    // { from: "commonline5", to: "non_potable_plant" }, 
     { from: "meter_195026", to: "non_potable_plant" }, 
  ],
};

// --- District 2 Schematic JSON (3-Level: 4 Wells -> Supply -> Tank -> Demand -> Total Demand) ---
export const schematicJSON_District2 = {
  nodes: [
    // --- Level 0: Sources and Total Supply ---
    { id: "well_1", type: "source", label: "Well 1", name: "Well_1"},
    { id: "well_2", type: "source", label: "Well 2", name: "Well_2" },
    { id: "well_3", type: "source", label: "Well 3", name: "Well_3" },
    { id: "well_4", type: "source", label: "Well 4", name: "Well_4" },
    { id: "total_supply", type: "supply", label: "Total Supply", name: "Total_Supply" },
    // { id: "surface_water", type: "label", label: "Surface Water", name: "Surface Water" },
    // --- Level 1: Storage ---
    { id: "dist2_tank", type: "storage", label: "Tank", name: "Tank" },

    // --- Level 2: Demand Meters and Total Demand ---
    { id: "meter_r", type: "meter", label: "Residential", name: "DKRP0", meterId:"DKRP0" },
    { id: "meter_c", type: "meter", label: "Commercial", name: "DKCP0", meterId:"DKCP0"},
    { id: "meter_d", type: "meter", label: "District Facility", name: "DKDP0", meterId:"DKDP0"},
    { id: "meter_i", type: "meter", label: "Irrigation", name: "DICP0",meterId:"DICP0" },
    { id: "meter_tr", type: "meter", label: "Tracking", name: "DIDP0",meterId:"DIDP0" },
    { id: "School_Irrigation", type: "meter", label: "School Irrigation", name: "DISP0",meterId:"DISP0" },
    { id: "HOA_Facility", type: "meter", label: "HOA Facility", name: "DKHP0",meterId:"DKHP0" },
    { id: "School", type: "meter", label: "School", name: "DKSP0",meterId:"DKSP0" },
    { id: "total_demand", type: "consumer", label: "Total Demand", name: "Total_Demand" },
  ],
  edges: [
    // --- Wells to Total Supply (Aggregates production) ---
    { from: "well_1", to: "total_supply" },
    { from: "well_2", to: "total_supply" },
    { from: "well_3", to: "total_supply" },
    { from: "well_4", to: "total_supply" },
    // { from: "surface_water", to: "total_supply" },
    // --- Total Supply to Tank (Level 0 to Level 1) ---
    { from: "total_supply", to: "dist2_tank" },

    // --- Tank to Demand Meters (Distribution from Level 1) ---
    { from: "dist2_tank", to: "meter_r" },
    { from: "dist2_tank", to: "meter_c" },
    { from: "dist2_tank", to: "meter_d" },
    { from: "dist2_tank", to: "meter_i" },
    { from: "dist2_tank", to: "meter_tr" },
    { from: "dist2_tank", to: "School_Irrigation" },
    { from: "dist2_tank", to: "School" },
    // { from: "dist2_tank", to: "Surface_Water" },
    { from: "dist2_tank", to: "HOA_Facility" },

    // --- Demand Meters to Total Demand (Aggregates consumption) ---
    { from: "meter_r", to: "total_demand" },
    { from: "meter_c", to: "total_demand" },
    { from: "meter_d", to: "total_demand" },
    { from: "meter_i", to: "total_demand" },
    { from: "meter_tr", to: "total_demand" },
    { from: "School_Irrigation", to: "total_demand" },
    { from: "School", to: "total_demand" },
    { from: "HOA_Facility", to: "total_demand" },
  ],
};
// --- Define Layout Constants ---
const Y_LEVEL_0 = 50;
const Y_SEPARATOR = 380; // The vertical distance between each main level
const Y_LEVEL_1 = Y_LEVEL_0 + Y_SEPARATOR;     // 430
const Y_LEVEL_2 = Y_LEVEL_1 + Y_SEPARATOR;     // 810
const Y_LEVEL_3 = Y_LEVEL_2 + Y_SEPARATOR+50;     // 1190
const Y_LEVEL_4 = Y_LEVEL_3 + Y_SEPARATOR;     // 1570

// Updated Original Layout Coordinates
export const fixedPositions_Original = {
    // --- LEVEL 0 (y = 50) ---
    tank: { x: 800, y: Y_LEVEL_0 },
    non_potable_reservoir: { x: 2000, y: Y_LEVEL_0 },
    meter_101893: { x: 400, y: Y_LEVEL_0 },
    meter_162902: { x: 1200, y: Y_LEVEL_0 },
    coh: { x: 1500, y: Y_LEVEL_0 },

    // --- LEVEL 1 (y ≈ 430) ---
    gp_well: { x: 200, y: Y_LEVEL_1 -18 }, // Original y: 320
    water_plant: { x: 650, y: Y_LEVEL_1 },
    non_potable_plant: { x: 2000, y: Y_LEVEL_1+1 }, // Original y: 410
    commonline5: { x: 2090, y: Y_LEVEL_2 + 256 }, // Original y: 460
    commonline8: { x: 1732, y: Y_LEVEL_2 + 430 }, // Original y: 460

    // --- LEVEL 2 (y = 810) ---
    north_distribution_meter: { x: 400, y: Y_LEVEL_2 },
    total_produced: { x: 800, y: Y_LEVEL_2 },
    south_distribution_meter: { x: 1200, y: Y_LEVEL_2 },
    meter_195026: { x: 1600, y: Y_LEVEL_2-10 },
    meter_206680: { x: 2300, y: Y_LEVEL_2 },
    commonline9: { x: 2400, y: Y_LEVEL_2 +80},
    // --- LEVEL 3 (y ≈ 1190) ---
    meter_150850: { x: 200, y: Y_LEVEL_3 },
    meter_150849: { x: 480, y: Y_LEVEL_3 },
    potable_supply: { x: 800, y: Y_LEVEL_3 +200 }, // Original y: 1240
    meter_129122: { x: 1300, y: Y_LEVEL_3 },
    meter_114476: { x: 1655, y: Y_LEVEL_3 },
    non_potable_supply: { x: 2000, y: Y_LEVEL_3 },
    meter_114477: { x: 2300, y: Y_LEVEL_3 },
    commonline: { x: 570, y: Y_LEVEL_3 - 50 }, // Original y: 1133
    commonline2: { x: 890, y: Y_LEVEL_3 - 30 }, // Original y: 1160
    commonline3: { x: 570, y: Y_LEVEL_3+350 }, // Original y: 1160
    commonline6: { x: 1290, y: Y_LEVEL_3 - 30 }, // Original y: 1160
    commonline7: { x: 290, y: Y_LEVEL_3+250 }, 
    commonline10: { x: 290, y: Y_LEVEL_3+350 }, 
    // --- LEVEL 4 (y = 1570) ---
    consumer_potable: { x: 800, y: Y_LEVEL_4+100 },
    consumer_non_potable: { x: 2000, y: Y_LEVEL_4+100 },
};


export const fixedPositions_District2 = {
    // --- LEVEL 0: Wells (Sources) and Total Supply ---
    well_1: { x: 100, y: Y_LEVEL_0 },
    well_2: { x: 300, y: Y_LEVEL_0 },
    well_3: { x: 500, y: Y_LEVEL_0 },
    well_4: { x: 700, y: Y_LEVEL_0 },
    // surface_water: { x: 900, y: Y_LEVEL_0+160 },
    total_supply: { x: 400, y: Y_LEVEL_0 + 350 }, 

    // --- LEVEL 1: Storage (Center) ---
    dist2_tank: { x: 400, y: Y_LEVEL_1 + 280},

    // --- LEVEL 2: Demand Meters and Total Demand ---
    meter_r: { x: -300,   y: Y_LEVEL_2 + 210 },
    meter_c: { x: -100, y: Y_LEVEL_2 + 210 },
    meter_d: { x: 100, y: Y_LEVEL_2 + 210 },
    meter_i: { x: 300, y: Y_LEVEL_2 + 210 },
    meter_tr: { x: 500, y: Y_LEVEL_2 + 210 },
    School_Irrigation: { x: 700, y: Y_LEVEL_2 + 210 },
    School: { x: 900, y: Y_LEVEL_2 + 210 },
    HOA_Facility: { x: 1100, y: Y_LEVEL_2 + 210 },

    total_demand: { x: 400, y: Y_LEVEL_2 + 590 },
};